import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Silence noisy cross-origin errors from TradingView widgets (snowplow tracker, sheriff API).
// These are harmless and originate from third-party iframes — they otherwise pollute the
// React dev error overlay and obscure real app errors.
const _isThirdPartyTVError = (msg, src) => {
  const m = String(msg || "");
  const s = String(src || "");
  if (s.includes("tradingview") || s.includes("tradingview-widget")) return true;
  if (m === "Script error." || m === "ResizeObserver loop limit exceeded") return true;
  if (m.includes("querySelector") && m.includes("null")) return true;
  return false;
};
window.addEventListener(
  "error",
  (e) => {
    if (_isThirdPartyTVError(e.message, e.filename)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);
window.addEventListener("unhandledrejection", (e) => {
  const r = e.reason;
  const msg = r && (r.message || String(r));
  if (_isThirdPartyTVError(msg, "")) {
    e.preventDefault();
  }
});

// Hide the webpack-dev-server runtime error overlay (it picks up cross-origin TV widget
// errors that we cannot suppress at the source). The overlay is dev-only — production
// builds are unaffected.
const _hideDevOverlay = () => {
  document.querySelectorAll("body > iframe").forEach((f) => {
    const id = f.id || "";
    const title = f.title || "";
    if (
      id.includes("webpack-dev-server-client-overlay") ||
      title.includes("webpack-dev-server") ||
      title.includes("Runtime errors")
    ) {
      f.style.display = "none";
    }
  });
};
const _overlayObserver = new MutationObserver(_hideDevOverlay);
_overlayObserver.observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

